import { jsx as _jsx } from "react/jsx-runtime";
import LegacyEvent from '../../../tabs/legacy/event';
import { SimpleMarker } from 'shared/map/ui/components/marker/simple';
import '../ui/markers.sass';
import { BlinkingMarker } from 'entities/device.map.stops/ui/blinking-marker';
import { a2l } from 'shared/map/lib/utils';
export function TrackingIcons(props) {
    const { icons, onShowEventOnMap } = props;
    return (_jsx("div", { children: (icons || []).map((icon, i) => {
            const common_props = {
                key: i,
                loc: [icon.x, icon.y],
                onClick: () => onShowEventOnMap(new LegacyEvent({
                    id: null,
                    x: icon.x,
                    y: icon.y,
                    time: icon.time ?? 0,
                    title: icon.title,
                    details: icon.details,
                })),
            };
            const { key, ...props_without_key } = common_props;
            if (icon.blinking_classes != null) {
                return (_jsx(BlinkingMarker, { position: a2l(common_props.loc), icon_classes: icon.blinking_classes, icon_size: icon.icon_size, ...props_without_key }, key));
            }
            else if (icon.icon_class != null) {
                return (_jsx(SimpleMarker, { position: a2l(common_props.loc), icon_class: icon.icon_class, icon_width: icon.icon_size, icon_height: icon.icon_size, ...props_without_key }, key));
            }
            return null;
        }) }));
}
